export default __webpack_public_path__ + "231d5f2d16f383619fc6df916b3c3bbb.svg";